import { Stack } from "@mui/material";
import { Button, CircularProgress } from "@nextui-org/react";
import React, { lazy, MouseEvent } from "react";
import { FaPlus } from "react-icons/fa";
import { useNavigate } from "react-router";
import ReachMaximumModal from "../../../components/common/ReachMaximumModal";
import Title from "../../../components/common/Title";
import { useFetchTrips } from "../../../hooks/useFetchTrips";
import { useManageTrip } from "../../../hooks/useManageTrip";
import { useModal } from "../../../hooks/useModal";
import { useStripeCustomerInfo } from "../../../hooks/useStripeCustomerInfo";
import MyTrips from "./MyTrips";

// const MAXIMUM_FREE_ITINERARY = 1;

const LoadingDestinations = lazy(
  () => import("../../../components/pages/home/LoadingDestinations")
);

const ItineraryList = () => {
  const {
    user,
    loadingUserInfo: loadingUser,
    stripeCustomerInfo,
  } = useStripeCustomerInfo();

  const navigate = useNavigate();

  // const { data: featureFlags } = useFetchFeatureFlags();

  // const isPaymentEnabled = featureFlags?.payment ?? false;

  const {
    data: itineraries,
    isPending: isLoadingItineraries,
    refetch: refreshTrips,
  } = useFetchTrips({
    userId: user?.id ?? null,
  });

  const { isOpen: isShowReachLimitModal, handleClose: closeReachLimitModal } =
    useModal();

  // const { data: createdItineraryNum, isFetching: isFetchingUserLog } =
  //   useFetchUserItineraryLog(user?.id ?? "");

  const { handleNavigateCreateTrip, handleDeleteTrip } = useManageTrip({
    stripeCustomerInfo,
  });

  if (loadingUser)
    return (
      <Stack className="h-[300px] items-center justify-center">
        <CircularProgress color="primary" label="โหลดข้อมูลผู้ใช้..." />
      </Stack>
    );

  console.log(itineraries);
  // const hasReachedLimit =
  //   (createdItineraryNum ?? MAXIMUM_FREE_ITINERARY) >= MAXIMUM_FREE_ITINERARY;

  return (
    <div className="flex flex-col w-full items-center gap-y-3 text-black">
      <Title text="ทริปที่ใกล้ถึง" position="left" />
      <ReachMaximumModal
        isOpen={isShowReachLimitModal}
        onClose={closeReachLimitModal}
        onConfirm={() => navigate("/pricing")}
      />
      {user ? (
        isLoadingItineraries ? (
          <LoadingDestinations />
        ) : itineraries.length > 0 ? (
          <MyTrips
            itineraries={itineraries}
            onDeleteItinerary={async (tripId) => {
              await handleDeleteTrip(tripId);
              refreshTrips();
            }}
          />
        ) : (
          <div className="h-[200px] w-full flex items-center justify-center">
            <h3 className="text-center text-black">คุณยังไม่มีแผนท่องเที่ยว</h3>
          </div>
        )
      ) : (
        <h3 className="h-[200px] text-center flex items-center justify-center">
          เข้าสู่ระบบเพื่อดูแผนท่องเที่ยวของคุณ
        </h3>
      )}
      <Button
        onClick={(e: MouseEvent<HTMLButtonElement>) => {
          // if (isFetchingUserLog || loadingUser) return;

          // if (!user) {
          //   navigate("/sign-in");
          //   return;
          // }

          // if (
          //   hasReachedLimit &&
          //   !Membership.isValid(stripeCustomerInfo) &&
          //   isPaymentEnabled
          // )
          //   return showReachLimitModal();

          handleNavigateCreateTrip(e);
        }}
        startContent={<FaPlus className="text-white" size={13} />}
        data-testid="create-trip-button"
        className="w-[148px] bg-primary text-[17px] min-h-[41px] mt-5 rounded-full hover:outline-none hover:border-none"
      >
        <p className="text-white font-semibold">เพิ่มแผนใหม่ </p>
      </Button>
    </div>
  );
};

export default ItineraryList;
